module.exports = __webpack_public_path__ + "static/media/logo-dropbox.3f0350cc.svg";